import axios from 'axios';
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { connect } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import { fetchJsonFromBack, saveJsonToBack } from '../../../store/jsonSlice';
import { FaTrash, FaSave, FaCopy, FaDownload } from "react-icons/fa";
import { deleteFile, uploadFile } from "../../../services/api/jsonService.ts";

import Title from "../../../components/Title";
import Button from "../../../components/Button";
import TextInput from "../../../components/TextInput";
import TextArea from "../../../components/TextArea";

const ProcedureManage = ({ loading, error }) => {
  // Hooks et états
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { chapterName, folderName: urlFolderName } = useParams();
  const jsonData = useSelector(state => state.json.jsonData);
  const steps = jsonData?.process?.steps || [];// récupération des étapes depuis jsonData
  const currentFolderName = useSelector(state => state.procedure.currentFolderName);
  const currentFilename = useSelector(state => state.procedure.currentFilename);
  /*let routeParams = useParams();
  const rootFolder = props.rootFolder || routeParams.rootFolder;
  const filename = props.filename || routeParams.filename;*/

  // Etat pour les fichiers en attente
  const [pendingHologram, setPendingHologram] = useState(null);

  // fonction pour le défilement vers la zone de contenu
  const scrollToContentArea = (ElementId) => {
    setTimeout(() => {
      const anchor = document.getElementById(ElementId);
      if (anchor) anchor.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  // États pour stocker les données de la procédure
  const [Contents, setContents] = useState({
    usage: "File of all the steps and actions related to a procedure. Contains all the operations that can be carried out, organized into stages, steps and actions.",
    contentVersion: "",
    ownerName: "",
    ownerIdentifier: "",
    appVersion: "",
    chapter: "",
    calibrateAfterStageID: 0,
    title: "",
    description: "",
    workspace: {
      shape: "",
      sizeX: "",
      sizeY: "",
      sizeZ: ""
    },
    workspaceShapeRotX: "", // rotation verticale (0) / horizontale (90)
    workspaceShapeRotY: "", // unused
    workspaceShapeRotZ: "", // unused
    workspaceOffsetPosX: "", // automatique
    workspaceOffsetPosY: "", // hauteur de la zone de travail
    workspaceOffsetPosZ: "", // automatique
    workspaceOffsetRotX: "", // Orientation Hor / vert (Select)
    workspaceOffsetRotY: "", // unused
    workspaceOffsetRotZ: "", // unused
    mainhologram: ""
  });

  /* let uploadFolderName   = undefined;
   } else if (rootFolder && filename) {
     folderName = `${rootFolder}/${filename}`;
   } else if (rootFolder) {
     folderName = rootFolder;
   }*/


  // État pour stocker la taille Y de la zone de travail (Calcul d'offset)
  const [sizeYInput, setSizeYInput] = useState(String(Contents.workspace.sizeY ?? 0));

  // État pour stocker le fichier téléchargé
  const [file, setFile] = useState(null);

  // Etat pour afficher/cacher les inputs offset Y/Z
  const [showOffsetInputs, setShowOffsetInputs] = useState(false);

  // État pour stocker le message de succès
  const [successMessage, setSuccessMessage] = useState('');

  // Logs détaillés
  useEffect(() => {
    // Afficher la structure détaillée
    console.log(' Structure détaillée :', {
      settings: jsonData?.settings,
      process: jsonData?.process,
      workspace: jsonData?.process?.workspaceShapeSize,
      rotations: jsonData?.process?.workspaceShapeRot,
      offsets: {
        pos: jsonData?.process?.workspaceOffsetPos,
        rot: jsonData?.process?.workspaceOffsetRot
      }
    });
  }, [jsonData, urlFolderName, currentFolderName, currentFilename]);

  // Initialiser les données quand le composant monte
  useEffect(() => {
    if (urlFolderName) {
      // Pour un dossier comme IRVE_BB, on veut:
      // - folderName: 'IRVE/IRVE_BB' (chemin complet du dossier)
      // - filename: 'IRVE_BB' (sans extension)
      const activeChapterName = chapterName || urlFolderName.split('_')[0];
      const folderPath = `${activeChapterName}/${urlFolderName}`;

      // Dispatch avec le bon chemin
      dispatch(fetchJsonFromBack({
        folderName: folderPath,
        filename: urlFolderName
      }));
    }
  }, [urlFolderName, dispatch]);

  // Initialiser les données dans le state local quand jsonData change
  useEffect(() => {
    if (!jsonData) return;

    const settings = jsonData.settings || {};
    const process = jsonData.process || {};
    const workspace = process.workspaceShapeSize || {};
    const shapeRot = process.workspaceShapeRot || {};
    const offsetPos = process.workspaceOffsetPos || {};
    const offsetRot = process.workspaceOffsetRot || {};

    setContents({
      usage: jsonData.Usage || "File of all the steps and actions related to a procedure. Contains all the operations that can be carried out, organized into stages, steps and actions.",
      contentVersion: settings?.contentVersion || "0",
      ownerName: settings?.ownerName || "",
      ownerIdentifier: settings?.ownerIdentifier || "",
      appVersion: settings?.appVersion || "",
      chapter: settings?.chapter || urlFolderName.split('_')[0],
      calibrateAfterStageID: settings?.calibrateAfterStageID || 0,
      title: process?.processTitle || "",
      description: process?.processDesc || "",
      workspace: {
        shape: process?.workspaceShape || "",
        sizeX: workspace.x !== undefined ? workspace.x : 0,
        sizeY: workspace.y !== undefined ? workspace.y : 0,
        sizeZ: workspace.z !== undefined ? workspace.z : 0,
      },
      workspaceShapeRotX: shapeRot.x !== undefined ? shapeRot.x : 0,
      workspaceShapeRotY: shapeRot.y !== undefined ? shapeRot.y : 0,
      workspaceShapeRotZ: shapeRot.z !== undefined ? shapeRot.z : 0,
      workspaceOffsetPosX: offsetPos.x !== undefined ? offsetPos.x : 0,
      workspaceOffsetPosY: offsetPos.y !== undefined ? offsetPos.y : 0,
      workspaceOffsetPosZ: offsetPos.z !== undefined ? offsetPos.z : 0,
      workspaceOffsetRotX: offsetRot.x !== undefined ? offsetRot.x : 0,
      workspaceOffsetRotY: offsetRot.y !== undefined ? offsetRot.y : 0,
      workspaceOffsetRotZ: offsetRot.z == 0, /* FORCE REINIT - HACK*/
      /*workspaceOffsetRotZ: offsetRot.z !== undefined ? offsetRot.z : 0,*/
      hologram: process?.mainHologram || ""
    });
  }, [jsonData, urlFolderName]);

  // Afficher le message de succès
  useEffect(() => {
    if (successMessage) {
      setTimeout(() => setSuccessMessage(''), 3000);
    }
  }, [successMessage]);
  // affiche la valeur du json dans  le champ "hauteur"
  useEffect(() => {
    setSizeYInput(String(Contents.workspace.sizeY ?? 0));
  }, [Contents.workspace.sizeY]);
  const handleChange = (field, value) => {
    setContents({ ...Contents, [field]: value });
  };

  const handleWorkspaceChange = (field, value) => {
    setContents({ ...Contents, workspace: { ...Contents.workspace, [field]: value } });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Fixe workspaceShapeRotZ à 0
    Contents.workspaceShapeRotZ = 0;
    try {
      // Créer une copie profonde des données existantes
      const existingData = JSON.parse(JSON.stringify(jsonData || {}));

      // S'assurer que la structure de base existe
      if (!existingData.process) {
        existingData.process = {};
      }

      // Préparer le process à sauvegarder (mainHologram sera "mainhologram.glb" si upload)
      const updatedProcess = {
        ...existingData.process,
        processTitle: Contents.title || '',
        processDesc: Contents.description || '',
        workspaceShape: Contents.workspace?.shape || '',
        steps: Array.isArray(existingData.process?.steps) ? [...existingData.process.steps] : [],
        stages: Array.isArray(existingData.process?.stages) ? [...existingData.process.stages] : [],
        workspaceShapeSize: {
          x: parseFloat(Contents.workspace?.sizeX) || 0,
          y: parseFloat(Contents.workspace?.sizeY) || 0,
          z: parseFloat(Contents.workspace?.sizeZ) || 0
        },
        workspaceShapeRot: {
          x: parseFloat(Contents.workspaceShapeRotX) || 0,
          y: parseFloat(Contents.workspaceShapeRotY) || 0,
          z: parseFloat(Contents.workspaceShapeRotZ) || 0
        },
        workspaceOffsetPos: {
          x: parseFloat(Contents.workspaceOffsetPosX) || 0,
          y: parseFloat(Contents.workspaceOffsetPosY) || 0,
          z: parseFloat(Contents.workspaceOffsetPosZ) || 0
        },
        workspaceOffsetRot: {
          x: parseFloat(Contents.workspaceOffsetRotX) || 0,
          y: parseFloat(Contents.workspaceOffsetRotY) || 0,
          z: parseFloat(Contents.workspaceOffsetRotZ) || 0
        },
        mainHologram: file ? 'mainHologram.glb' : (existingData.process?.mainHologram || '')
      };

      // Mettre à jour les paramètres
      const appVersionValue = Contents.appVersion || existingData.settings?.AppVersion || '0.1';
      const updatedSettings = {
        ...(existingData.settings || {}),

        contentVersion: Contents.contentVersion || 0,
        ownerName: Contents.ownerName || '',
        ownerIdentifier: Contents.ownerIdentifier || '',
        appVersion: appVersionValue,
        chapter: Contents.chapter || '',
        calibrateAfterStageID: Contents.calibrateAfterStageID || 0
      };

      // Créer l'objet final à sauvegarder
      const usageValue = Contents.usage || jsonData?.usage || "File of all the steps and actions related to a procedure. Contains all the operations that can be carried out, organized into stages, steps and actions.";
      const dataToSave = {
        ...existingData,
        usage: usageValue,
        settings: updatedSettings,
        process: updatedProcess
      };

      // Créer une copie de Contents pour les modifications
      let updatedContents = { ...Contents };
      let uploadFolderName = currentFolderName || urlFolderName;
      let base = uploadFolderName.replace(/\.json$/, ''); // ex: cc_MP
      let chapter = base.split('_')[0]; // ex: cc
      let folder = `${chapter}/${base}`; // ex: cc/cc_MP
      if (pendingHologram) {
        const hologramFileName = await uploadFile({
          file: pendingHologram,
          params: [],
          folder: folder,
          suffix: "Hologram",
          defaultExt: ".glb"
        });
        updatedProcess.mainHologram = 'mainHologram.glb';
        console.log("test: ", dataToSave.process.mainHologram);
      }

      // 2. Sauvegarder le JSON (mainHologram sera toujours mainHologram.glb si upload)
      dispatch({ type: 'json/updateJsonData', payload: dataToSave });
      await dispatch(saveJsonToBack(dataToSave));
      setSuccessMessage('Données enregistrées avec succès !');
      console.log('Données sauvegardées avec succès');
    } catch (error) {
      console.error('Erreur lors de la sauvegarde :', error);
      alert('Erreur lors de la sauvegarde des données.');
    }
  };

  //unused ???
  const handleDownloadHologram = async () => {
    let folderName = currentFolderName || urlFolderName;
    if (folderName && folderName.endsWith('.json')) {
      folderName = folderName.replace(/\.json$/, '');
    }

    let downloadFolderPath = folderName;
    if (folderName && folderName.includes('_')) {
      const parts = folderName.split('_');
      if (parts.length > 1) {
        const parentChapter = parts[0];
        downloadFolderPath = parentChapter + '/' + folderName;
      }
    }

    try {
      const response = await axios.get(`/api/upload/download-hologram/${downloadFolderPath}`, {
        responseType: 'blob',
        withCredentials: true
      });

      // Créer un blob et télécharger le fichier
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/octet-stream' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'mainHologram.glb');
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      console.log(url);


      console.log('Fichier mainHologram.glb téléchargé avec succès');
    } catch (err) {
      alert('Erreur lors du téléchargement du fichier.');
      console.error(err);
    }
  };

  //unused ???
  const handleDeleteHologram = async () => {
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer ce fichier ?")) {
      return;
    }
    let folderName = currentFolderName || urlFolderName;
    if (folderName && folderName.endsWith('.json')) {
      folderName = folderName.replace(/\.json$/, '');
    }
    // Correction : applique la même logique que l'upload pour gérer les sous-dossiers éventuels
    // Ex: si folderName contient un '_', il faut peut-être préfixer avec le parent
    let deleteFolderPath = folderName;
    if (folderName && folderName.includes('_')) {
      const parts = folderName.split('_');
      if (parts.length > 1) {
        const parentChapter = parts[0];
        // Vérifie si le dossier parent existe côté backend (même logique que l'upload)
        deleteFolderPath = parentChapter + '/' + folderName;
      }
    }
    try {
      await axios.delete(`/api/data/delete-hologram/${deleteFolderPath}`, { withCredentials: true });
      // Met à jour mainHologram côté JSON backend
      const updatedProcess = {
        ...jsonData.process,
        mainHologram: ''
      };
      const updatedSettings = {
        ...(jsonData.settings || {})
      };
      const dataToSave = {
        ...jsonData,
        settings: updatedSettings,
        process: updatedProcess
      };
      dispatch({ type: 'json/updateJsonData', payload: dataToSave });
      await dispatch(saveJsonToBack(dataToSave));
      setContents((prev) => ({
        ...prev,
        mainHologram: '',
        hologram: ''
      }));
      setFile(null);
      //alert('Fichier et JSON mis à jour avec succès !');
    } catch (err) {
      alert('Erreur lors de la suppression du fichier.');
      console.error(err);
    }
  };

  const handleCancel = () => navigate(-1);

  if (loading) return <div>Chargement des informations...</div>;
  if (error) return <div className="alert alert-danger">{error.message || String(error)}</div>;

  return (
    <div className="form-container p-4" alt="titre de la procédure">
      <Title text={
        `Paramètre des procédures`}
        className="text-center text-primary" />
      {/*<div className="col-md-6 text-center small mx-auto mb-4">
        (Survolez les ℹ️ pour obtenir des informations complémentaires.)
      </div>*/}
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-4" title="Numero ou référence de version
          Peut correspondre à la version du document original
          (non visible dans iXiWORK)">
            <TextInput
              label="Version ℹ️"
              placeholder="Ex : 01-2025-revision 1"
              value={Contents.contentVersion}
              onChange={(e) => handleChange("contentVersion", e.target.value)}
            />
          </div>
          <div className="col-md-4" title="Nom du propriétaire de la procédure
          (généralement le fabricant - non visible)">
            <TextInput
              label="Nom du propriétaire ℹ️"
              placeholder="Nom de la structure"
              value={Contents.ownerName}
              onChange={(e) => handleChange("ownerName", e.target.value)}
            />
          </div>
          <div className="col-md-4" title="Identifiant numérique du propriétaire
          (Généralement le N° de siret ou TVA intra-communautaire - non visible)">
            <TextInput
              label="Identifiant du propriétaire ℹ️"
              placeholder="SIRET, N°d'aggrément..."
              value={Contents.ownerIdentifier}
              onChange={(e) => handleChange("ownerIdentifier", e.target.value)}
            />
          </div>
        </div>
        <div alt="Annuler / confirmer" className="d-flex justify-content-center gap-3 mt-4">
            <Button
              text="Annuler"
              className="btn btn-outline-secondary btn-lg ms-5"
              onClick={handleCancel}
            />
            <Button
              text="Enregistrer"
              type="submit"
              className="btn btn-outline-primary btn-lg me-5"
            />
          </div>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.json.loading,
  error: state.json.error,
  jsonData: state.json.jsonData
});

export default connect(mapStateToProps)(ProcedureManage);

//Creators : Florian Cohen-Joly @3DDGAMES -- Under license
